import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { defineComponent, watchEffect ,onMounted, reactive} from "vue";
import stateStore from "./utils/store";
import storeControle from "./utils/storeControle";
import {getToken} from "./utils/funcoes";

import MainHeader from "./components/Layouts/MainHeader.vue";
import MainSidebar from "./components/Layouts/MainSidebar.vue";
import MainFooter from "./components/Layouts/MainFooter.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


const stateStoreInstance = stateStore;

onMounted(()=> {
    console.log("montando...");
    document.body.classList.add("bg-body-secondary");
    storeControle.token = getToken();

})

watchEffect(async () => {
  if (stateStoreInstance.open) {
      document.body.classList.remove("sidebar-show");
      document.body.classList.add("sidebar-hide");
    } else {
      document.body.classList.remove("sidebar-hide");
      document.body.classList.add("sidebar-show");
  }
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(storeControle).token != '')
      ? (_openBlock(), _createBlock(MainHeader, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(storeControle).token != '')
      ? (_openBlock(), _createBlock(MainSidebar, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(_unref(storeControle).token != '' ? 'main-content d-flex flex-column transition overflow-hidden' : '')
    }, [
      _createVNode(_component_router_view),
      (_unref(storeControle).token != '')
        ? (_openBlock(), _createBlock(MainFooter, { key: 0 }))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}
}

})